import styled, { css } from 'styled-components';

/**
 * These styles are used to appease a design desire to hide an element without
 * making it inaccessible to users of assitive technology.
 *
 * @see https://reach.tech/visually-hidden
 */
export const visuallyHidden = css`
  border: none;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  word-wrap: normal;
`;

/**
 * This element is used to appease a design desire to hide an element without
 * making it inaccessible to users of assitive technology.
 *
 * @see https://reach.tech/visually-hidden
 */
export const VisuallyHiddenElement = styled.span`
  ${visuallyHidden}
`;
